module.exports = __webpack_public_path__ + "static/media/thumbs-up.3d45caa9.svg";